import React from "react";
import { Search, XCircle } from "lucide-react";
import { colors, spacing, fonts } from "@/theme";

const RANGES = [
  { key: "all", label: "All time" },
  { key: "today", label: "Today" },
  { key: "week", label: "7 days" },
  { key: "month", label: "30 days" },
];

export function rangeToSince(range) {
  const now = new Date();
  if (range === "all") return null;
  if (range === "today") {
    const d = new Date(now);
    d.setHours(0, 0, 0, 0);
    return d;
  }
  if (range === "week") {
    const d = new Date(now);
    d.setDate(d.getDate() - 7);
    return d;
  }
  if (range === "month") {
    const d = new Date(now);
    d.setDate(d.getDate() - 30);
    return d;
  }
  return null;
}

export function MoveFilters({ search, onSearchChange, range, onRangeChange, placeholder = "Search trailer or location" }) {
  return (
    <div style={s.wrap}>
      <div style={s.searchBox}>
        <Search size={18} color={colors.onSurfaceTertiary} />
        <input
          data-testid="move-search"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={placeholder}
          style={s.input}
        />
        {search.length > 0 ? (
          <button data-testid="move-search-clear" onClick={() => onSearchChange("")} style={s.clearBtn}>
            <XCircle size={18} color={colors.onSurfaceTertiary} />
          </button>
        ) : null}
      </div>
      <div style={s.rangeRow}>
        {RANGES.map((r) => {
          const active = range === r.key;
          return (
            <button
              key={r.key}
              data-testid={`range-${r.key}`}
              onClick={() => onRangeChange(r.key)}
              style={{ ...s.rangeChip, ...(active ? s.rangeChipActive : {}) }}
            >
              <span style={{ ...s.rangeText, color: active ? colors.onBrandPrimary : colors.onSurfaceTertiary }}>{r.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

const s = {
  wrap: { padding: `${spacing.md}px ${spacing.xl}px 0`, display: "flex", flexDirection: "column", gap: spacing.sm },
  searchBox: {
    display: "flex", alignItems: "center", gap: spacing.sm, borderWidth: 2, borderStyle: "solid", borderColor: colors.onSurface,
    backgroundColor: colors.surfaceSecondary, padding: `10px ${spacing.md}px`,
  },
  input: { flex: 1, ...fonts.mono, fontSize: 14, color: colors.onSurface, border: "none", outline: "none", background: "transparent" },
  clearBtn: { border: "none", background: "transparent", cursor: "pointer", padding: 0, display: "flex" },
  rangeRow: { display: "flex", flexWrap: "wrap", gap: spacing.sm },
  rangeChip: { padding: `8px ${spacing.md}px`, borderWidth: 2, borderStyle: "solid", borderColor: colors.borderStrong, backgroundColor: colors.surfaceSecondary, cursor: "pointer" },
  rangeChipActive: { backgroundColor: colors.brandPrimary, borderColor: colors.brandPrimary },
  rangeText: { ...fonts.monoBold, fontSize: 11, letterSpacing: 0 },
};
